import { alpha, styled as muiStyled } from '@mui/material/styles';
import { abyssColors, primary } from '@/theme/colors';
import { Button } from '@mui/material';

export const TabPill = muiStyled(Button)(({ selected }: { selected: boolean }) => ({
  whiteSpace: 'nowrap',
  fontSize: '1.3rem',
  boxShadow: 'none',
  height: '32px',
  borderRadius: '32px',
  padding: '8px 10px',
  display: 'flex',
  alignItems: 'center',
  textTransform: 'none',
  fontWeight: '400',
  backgroundColor: selected ? abyssColors.primary[600] : alpha(primary.light, 0.2),
  color: selected ? abyssColors.neutral[50] : 'black',
  '&:hover': { backgroundColor: selected ? abyssColors.primary[600] : alpha(primary.light, 0.2) },
  '&:disabled': { backgroundColor: alpha(primary.light, 0.2), color: abyssColors.primary[300] },
}));
